"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const IconCoin_1 = __importDefault(require("../../assets/icons/IconCoin"));
const IconComment_1 = __importDefault(require("../../assets/icons/IconComment"));
const IconLike_1 = __importDefault(require("../../assets/icons/IconLike"));
const Threedoc_1 = __importDefault(require("../../assets/icons/Threedoc"));
const images_1 = require("../../assets/images");
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const rootNavigation_1 = require("../../navigators/rootNavigation");
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const ItemArticles = (props) => {
    const { data } = props;
    return (react_1.default.createElement(react_native_1.View, { style: {
            width: '100%',
            alignItems: 'center',
            paddingVertical: (0, scale_1.scale)(12),
            borderBottomWidth: (0, scale_1.scale)(1),
            borderColor: '#DDDDDD'
        } },
        react_1.default.createElement(react_native_1.Pressable, { onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.DETAIL_STORY, { id: data.id }) },
            react_1.default.createElement(react_native_1.Image, { source: data?.imagesArticles ? { uri: data?.imagesArticles } : images_1.images.NoImages, style: {
                    height: (0, scale_1.scale)(192),
                    width: (0, scale_1.scale)(343),
                    borderRadius: (0, scale_1.scale)(20),
                }, resizeMode: "cover" })),
        react_1.default.createElement(react_native_1.View, { style: { width: (0, scale_1.scale)(343) } },
            react_1.default.createElement(react_native_1.View, { style: {
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: (0, scale_1.scale)(16),
                } },
                react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: {
                        fontSize: (0, scale_1.moderateScale)(14),
                        lineHeight: (0, scale_1.moderateScale)(21),
                        fontWeight: "300",
                        maxWidth: (0, scale_1.scale)(300),
                    } }, data?.content),
                react_1.default.createElement(react_native_1.TouchableOpacity, null,
                    react_1.default.createElement(Threedoc_1.default, null))),
            react_1.default.createElement(react_native_1.View, { style: { marginTop: (0, scale_1.scale)(12) } },
                react_1.default.createElement(react_native_1.View, { style: {
                        flexDirection: "row",
                        maxWidth: (0, scale_1.scale)(300),
                        flexWrap: "wrap",
                    } }, data?.hashtag?.map((text) => {
                    return (react_1.default.createElement(CustomText_1.default, { style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            fontWeight: "300",
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#007AFF",
                        } }, text));
                })),
                data?.coin && (react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row", marginTop: (0, scale_1.scale)(12) } },
                    react_1.default.createElement(IconCoin_1.default, null),
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontSize: (0, scale_1.moderateScale)(12),
                            lineHeight: (0, scale_1.moderateScale)(16),
                            fontWeight: "300",
                            marginLeft: (0, scale_1.scale)(5),
                        } }, `${data.coin}コイン`))),
                react_1.default.createElement(react_native_1.View, { style: {
                        flexDirection: "row",
                        paddingVertical: (0, scale_1.scale)(12),
                        width: (0, scale_1.scale)(343),
                        paddingTop: (0, scale_1.scale)(12),
                    } },
                    react_1.default.createElement(react_native_1.View, { style: { width: (0, scale_1.scale)(52) } },
                        react_1.default.createElement(react_native_1.Image, { source: data?.image ? { uri: data?.image } : images_1.images.AvatarDefaul, style: {
                                height: (0, scale_1.scale)(40),
                                width: (0, scale_1.scale)(40),
                                borderRadius: (0, scale_1.scale)(20),
                            } })),
                    react_1.default.createElement(react_native_1.View, { style: { width: (0, scale_1.scale)(290) } },
                        react_1.default.createElement(react_native_1.View, { style: {
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                            } },
                            react_1.default.createElement(react_native_1.View, null,
                                react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                                    react_1.default.createElement(CustomText_1.default, { weight: "600", numberOfLines: 1, style: {
                                            fontSize: (0, scale_1.moderateScale)(14),
                                            lineHeight: (0, scale_1.moderateScale)(21),
                                            maxWidth: (0, scale_1.scale)(200),
                                        } }, data?.nameUser),
                                    react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: {
                                            fontSize: (0, scale_1.moderateScale)(10),
                                            lineHeight: (0, scale_1.moderateScale)(15),
                                            fontWeight: "200",
                                            color: "#7C7C7C",
                                            marginLeft: (0, scale_1.scale)(12),
                                            marginTop: (0, scale_1.scale)(2),
                                        } }, data?.time)),
                                react_1.default.createElement(react_native_1.View, { style: {
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    } },
                                    react_1.default.createElement(CustomText_1.default, { style: {
                                            maxWidth: (0, scale_1.scale)(240),
                                            fontSize: (0, scale_1.moderateScale)(10),
                                            lineHeight: (0, scale_1.moderateScale)(15),
                                            marginTop: (0, scale_1.scale)(5),
                                            color: "#545454",
                                        } }, data?.tagnameUser),
                                    data?.timenow && (react_1.default.createElement(CustomText_1.default, { style: {
                                            fontSize: (0, scale_1.moderateScale)(9),
                                            fontWeight: "300",
                                            lineHeight: (0, scale_1.moderateScale)(14),
                                            color: "#FEFEFE",
                                            backgroundColor: "black",
                                            left: (0, scale_1.scale)(32),
                                            paddingHorizontal: (0, scale_1.scale)(2),
                                        } }, data?.timenow))))))),
                react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row", marginTop: (0, scale_1.scale)(12) } },
                    react_1.default.createElement(IconComment_1.default, { color: data?.numberComment > 0 ? "#44A06B" : "#545454" }),
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontSize: (0, scale_1.moderateScale)(12),
                            fontWeight: "300",
                            lineHeight: (0, scale_1.moderateScale)(18),
                            color: data?.numberComment > 0 ? "#44A06B" : "#545454",
                            marginLeft: (0, scale_1.scale)(8),
                        } }, data?.numberComment),
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row", marginLeft: (0, scale_1.scale)(24) } },
                        react_1.default.createElement(IconLike_1.default, { color: data?.numberLikes > 0 ? "#44A06B" : "#545454" }),
                        react_1.default.createElement(CustomText_1.default, { style: {
                                fontSize: (0, scale_1.moderateScale)(12),
                                fontWeight: "300",
                                lineHeight: (0, scale_1.moderateScale)(18),
                                color: data?.numberLikes > 0 ? "#44A06B" : "#545454",
                                marginLeft: (0, scale_1.scale)(8),
                                marginRight: (0, scale_1.scale)(24),
                            } }, data?.numberLikes)))))));
};
exports.default = ItemArticles;
